import React from 'react'

import { Card } from 'primereact/card';
import { AuthContext } from '../../main/ProvedorAutenticacao'
import { withRouter } from 'react-router-dom'
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable' 
import { Dropdown } from 'primereact/dropdown'
import { InputText } from 'primereact/inputtext'
import { Column } from 'primereact/column'
import { Dialog } from 'primereact/dialog'
import { Toast } from 'primereact/toast';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import GraficosService from '../../app/service/GraficoPessoasService'

import '../../pages/processo/calendario.css'

class CardPainelPessoas extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      totalPessoas: '',
      totalAtivas: '',
      percentualAtivos: '',
      totalInativas: '',
      percentualInativas: '',
      totalComProcessos: '',
      percentualComProcessos: '',
      percentualSemProcessos: '',
      totalEsteMes: '',
      percentualEsteMes: '',
      aniversariantesList: [],
      filtro: null,
      aniversariantes: '',
      percentualAniversariantes: '',
      mes: null,
      idade: '',
      modalAniversariantes: false,
      openSpinner: false,
      detail: '',
      paramAniversariantes: '',
    }

    this.meses = [
      {codigo: 1, nome: 'Janeiro'},
      {codigo: 2, nome: 'Fevereiro'},
      {codigo: 3, nome: 'Março'},
      {codigo: 4, nome: 'Abril'},
      {codigo: 5, nome: 'Maio'},
      {codigo: 6, nome: 'Junho'},
      {codigo: 7, nome: 'Julho'},
      {codigo: 8, nome: 'Agosto'},
      {codigo: 9, nome: 'Setembro'},
      {codigo: 10, nome: 'Outubro'},
      {codigo: 11, nome: 'Novembro'},
      {codigo: 12, nome: 'Dezembro'}
    ]

    this.graficoService = new GraficosService();
  }

  aniversariantes = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    var mesDefault = "";
    if(this.state.mes == null) {
      const hoje = new Date();
      const mesAtual = hoje.getMonth() + 1;
      mesDefault = mesAtual;
      for(let i = 0; i < this.meses.length; i++) {
        if(mesAtual == this.meses[i].codigo) {
          this.setState({mes: this.meses[i]});
        }
      }
    } else {
      mesDefault = this.state.mes.codigo;
    }
    var idade = '';
    if(this.state.idade == '') {
      idade = 0;
    } else {
      idade = this.state.idade;
    }
    const filtro = {
      empresa: usuarioLogado.empresa.codigo,
      mes: mesDefault,
      idade: idade
    }
    this.setState({filtro: filtro});
    await this.graficoService.aniversariantes(filtro)
      .then(response => {
        this.setState({aniversariantesList: response.data});
        this.setState({aniversariantes: response.data.length});
        const percent = parseInt(response.data.length)/parseInt(this.state.totalPessoas) * 100;
        this.setState({percentualAniversariantes: percent.toFixed(0)});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Total Pessoas', detail:`${this.state.detail}`, life: 4000});
      })
  }

  exibirAniversariantes = () => {
    this.abrirModal('modalAniversariantes');
  }

  consultarAniversariantes = async () => {
    this.setState({openSpinner: true});
    await this.aniversariantes();
    this.setState({openSpinner: false});
  }

  imprimir = () => {
    this.setState({paramAniversariantes: `#/aniversariantes/${this.state.filtro.empresa}/${this.state.filtro.mes}/${this.state.filtro.idade}`});
  }

  totalPessoas = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.graficoService.totalPessoas(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({totalPessoas: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Total Pessoas', detail:`${this.state.detail}`, life: 4000});
      })
  }

  totalAtivas = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.graficoService.totalAtivas(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({totalAtivas: response.data});
        if(response.data == this.state.totalPessoas) {
          this.setState({percentualAtivos: '100'});
        } else {
          const percent = parseInt(response.data)/parseInt(this.state.totalPessoas) * 100;
          this.setState({percentualAtivos: percent.toFixed(0)});
        }
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Total Ativas', detail:`${this.state.detail}`, life: 4000});
      })
  }

  totalInativas = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.graficoService.totalInativas(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({totalInativas: response.data});
        if(response.data == this.state.totalPessoas) {
          this.setState({percentualInativas: '100'});
        } else {
          const percent = parseInt(response.data)/parseInt(this.state.totalPessoas) * 100;
          this.setState({percentualInativas: percent.toFixed(0)});
        }
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Total Inativas', detail:`${this.state.detail}`, life: 4000});
      })
  }

  totalComProcessos = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.graficoService.totalComProcessos(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({totalComProcessos: response.data});
        if(response.data == this.state.totalPessoas) {
          this.setState({percentualComProcessos: '100'});
        } else {
          const percent = parseInt(response.data)/parseInt(this.state.totalPessoas) * 100;
          this.setState({percentualComProcessos: percent.toFixed(0)});
        }
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Total com Procesos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  totalSemProcessos = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.graficoService.totalSemProcessos(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({totalSemProcessos: response.data});
        if(response.data == this.state.totalPessoas) {
          this.setState({percentualSemProcessos: '100'});
        } else {
          const percent = parseInt(response.data)/parseInt(this.state.totalPessoas) * 100;
          this.setState({percentualSemProcessos: percent.toFixed(0)});
        }
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Total sem Procesos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  totalCadastradosEsteMes = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.graficoService.totalCadastradosEsteMes(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({totalEsteMes: response.data});
        if(response.data == this.state.totalPessoas) {
          this.setState({percentualEsteMes: '100'});
        } else {
          const percent = parseInt(response.data)/parseInt(this.state.totalPessoas) * 100;
          this.setState({percentualEsteMes: percent.toFixed(0)});
        }
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Total Cadastrados este Mês', detail:`${this.state.detail}`, life: 4000});
      })
  }

  async componentDidMount() {
    this.setState({openSpinner: true});
    await this.totalPessoas();
    await this.totalAtivas();
    await this.totalInativas();
    await this.totalComProcessos();
    await this.totalSemProcessos();
    await this.aniversariantes();
    this.setState({openSpinner: false});
  }

  fecharModal(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  abrirModal(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  render() {
    return(
      <>
        <Toast ref={(el) => this.toast = el} />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.openSpinner}>
          <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
        </Backdrop>
        <div className="card-body">
          <div className="row">
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-2">
                  <div className="cardMiniAgendaPainel">
                    <Card title="Pessoas">
                        <p>
                          <h3>{this.state.totalPessoas}</h3> 100%
                        </p>
                    </Card>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="cardMiniAgendaPainel">
                    <Card title="Ativas">
                        <p>
                          <h3>{this.state.totalAtivas}</h3>{this.state.percentualAtivos}%
                        </p>
                    </Card>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="cardMiniAgendaPainel">
                    <Card title="Inativas">
                        <p>
                          <h3>{this.state.totalInativas}</h3>{this.state.percentualInativas}%
                        </p>
                    </Card>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="cardMiniAgendaPainel">
                    <Card title="Com Processos">
                        <p>
                          <h3>{this.state.totalComProcessos}</h3>{this.state.percentualComProcessos}%
                        </p>
                    </Card>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="cardMiniAgendaPainel">
                    <Card title="Sem Processos">
                        <p>
                          <h3>{this.state.totalSemProcessos}</h3>{this.state.percentualSemProcessos}%
                        </p>
                    </Card>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="cardMiniAgendaPainel">
                    <Card title="Aniversariantes do Mês">
                        <p>
                          <h3>
                            <a onClick={this.exibirAniversariantes}
                               style={{cursor: 'pointer'}}>
                            {this.state.aniversariantes}</a></h3>{this.state.percentualAniversariantes}%
                        </p>
                    </Card>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Dialog header="Aniversariantes do Mês"
                  visible={this.state.modalAniversariantes} 
                  footer={
                    <div className="right">
                        <Button label="Fechar" 
                                className="p-button-secondary p-button-text"
                                onClick={() => this.fecharModal('modalAniversariantes')}/>
                    </div>
                  } 
                  onHide={() => this.fecharModal('modalAniversariantes')}>
              
              <div className="row">
                <div className="col-sm-4">
                  <div className="form-group">
                    <Dropdown value={this.state.mes} 
                              options={this.meses} style={{width: '100%', height: '32px'}}
                              optionLabel="nome" 
                              onChange={e => this.setState({mes: e.target.value})}
                              id="mes"
                              className="p-inputtext-sm p-d-block p-mb-1"/>
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="form-group">
                    <InputText id="idade" 
                               type="text" 
                               style={{width: '100%', height: '32px'}} 
                               value={this.state.idade}
                               onChange={e => this.setState({idade: e.target.value})}
                               placeholder="Filtrar por Idade"
                               className="p-inputtext-sm p-d-block p-mb-1"/>
                  </div>
                </div>
                <div className="col-sm-2">
                  <div className="form-group">
                    <Button label="Consultar" 
                            className="p-button-primary p-button-text"
                            onClick={this.consultarAniversariantes}/> 
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4">
                  <div className="form-group">
                    <div className="product-name" style={{textAlign: 'left'}}><a className="cursor" 
                                                  href={this.state.paramAniversariantes}
                                                  target="_blank"
                                                  onClick={this.imprimir}>Imprimir</a></div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <DataTable value={this.state.aniversariantesList}  alwaysShowPaginator responsiveLayout="scroll"
                               paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                               currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10} emptyMessage=" "
                               paginatorRight selectionMode="multiple">
                      <Column field="nome" header="Nome"></Column>
                      <Column field="dataNascimento" header="Data Nascimento"></Column>
                      <Column field="email" header="E-mail"></Column>
                      <Column field="idade" header="Idade"></Column>
                    </DataTable>
                  </div>
                </div>
              </div>
            </Dialog>
        </div>
      </>
    )
  }
}
CardPainelPessoas.contextType = AuthContext;
export default withRouter(CardPainelPessoas)
